import React from "react";
import {enqueueSnackbar, SnackbarProvider} from "notistack";

// Available severity levels
export const SNACKBAR_MESSAGE_SEVERITY_DEFAULT = "default";
export const SNACKBAR_MESSAGE_SEVERITY_INFO = "info";
export const SNACKBAR_MESSAGE_SEVERITY_SUCCESS = "success";
export const SNACKBAR_MESSAGE_SEVERITY_WARNING = "warning";
export const SNACKBAR_MESSAGE_SEVERITY_ERROR = "error";

// Global function to show a message from anywhere
export const showMessage = (message, severity = SNACKBAR_MESSAGE_SEVERITY_DEFAULT) => {
  enqueueSnackbar(message, {
    variant: severity
  });
};

// Wrapper component to be used
const CustomSnackbarProvider = ({children}) => {
  return (
    <SnackbarProvider
      anchorOrigin={{vertical: "top", horizontal: "center"}}
      autoHideDuration={5000}
      maxSnack={3}
      className="snackbar-message"
    >
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;
